import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { supabase } from './supabaseClient';
import { api } from './api';
import { Auth } from './components/Auth';
import AppLayout from './layouts/AppLayout';
import Dashboard from './pages/Dashboard';
import Watchlist from './pages/Watchlist';
import Trades from './pages/Trades';
import Performance from './pages/Performance';
import Strategy from './pages/Strategy';
import Backtest from './pages/Backtest';
import Optimizer from './pages/Optimizer';
import BotControl from './pages/BotControl';
import Portfolio from './pages/Portfolio';
import Settings from './pages/Settings';
import Alerts from './pages/Alerts';
import { StrategyProvider } from './StrategyContext';
import './App.css';

function App() {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      setLoading(false);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  // Fetch admin status when user changes
  useEffect(() => {
    if (user) {
      api.getUserProfile()
        .then((profile: any) => setIsAdmin(profile?.is_admin ?? false))
        .catch(() => setIsAdmin(false));
    } else {
      setIsAdmin(false);
    }
  }, [user]);

  const handleSignOut = async () => {
    await supabase.auth.signOut();
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center">
        <div className="text-white text-xl">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Auth onAuthSuccess={() => {
      supabase.auth.getSession().then(({ data: { session } }) => {
        setUser(session?.user ?? null);
      });
    }} />;
  }

  return (
    <StrategyProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<AppLayout userEmail={user.email} onSignOut={handleSignOut} isAdmin={isAdmin} />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/watchlist" element={<Watchlist userId={user.id} />} />
            <Route path="/trades" element={<Trades />} />
            <Route path="/performance" element={<Performance />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/strategy" element={<Strategy isAdmin={isAdmin} />} />
            <Route path="/backtest" element={<Backtest isAdmin={isAdmin} />} />
            <Route path="/optimizer" element={<Optimizer isAdmin={isAdmin} />} />
            <Route path="/bot" element={<BotControl />} />
            <Route path="/alerts" element={<Alerts userId={user.id} isAdmin={isAdmin} />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </StrategyProvider>
  );
}

export default App;
